"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ATTACHMENT_EMPTY () {
        return _attachmenterrors.ATTACHMENT_EMPTY;
    },
    get ATTACHMENT_EXTENSIONS_BY_KIND () {
        return _attachmentkind.ATTACHMENT_EXTENSIONS_BY_KIND;
    },
    get ATTACHMENT_FILE_NAME_MAX () {
        return _attachmentkind.ATTACHMENT_FILE_NAME_MAX;
    },
    get ATTACHMENT_INFECTED () {
        return _attachmenterrors.ATTACHMENT_INFECTED;
    },
    get ATTACHMENT_KINDS () {
        return _attachmentkind.ATTACHMENT_KINDS;
    },
    get ATTACHMENT_MAX_BYTES () {
        return _attachmentkind.ATTACHMENT_MAX_BYTES;
    },
    get ATTACHMENT_MIME_BY_KIND () {
        return _attachmentkind.ATTACHMENT_MIME_BY_KIND;
    },
    get ATTACHMENT_TOO_LARGE () {
        return _attachmenterrors.ATTACHMENT_TOO_LARGE;
    },
    get ATTACHMENT_TYPE_NOT_ALLOWED () {
        return _attachmenterrors.ATTACHMENT_TYPE_NOT_ALLOWED;
    },
    get AttachmentKindSchema () {
        return _attachmentkind.AttachmentKindSchema;
    },
    get AttachmentScanStatusSchema () {
        return _patientattachment.AttachmentScanStatusSchema;
    },
    get PatientAttachmentCreateResponseSchema () {
        return _patientattachment.PatientAttachmentCreateResponseSchema;
    },
    get PatientAttachmentListResponseSchema () {
        return _patientattachment.PatientAttachmentListResponseSchema;
    },
    get PatientAttachmentSchema () {
        return _patientattachment.PatientAttachmentSchema;
    }
});
const _attachmentkind = require("./attachment-kind");
const _patientattachment = require("./patient-attachment");
const _attachmenterrors = require("./attachment-errors");
